export { SearchIcon } from './searchIcon';
